import { InternalAxiosRequestConfig } from "axios";
import { gatewayConfig } from "../../feat/gatewayClient/config";
export const baseUrlGatewayRequestInterceptor = (request: InternalAxiosRequestConfig) => {
  request.baseURL = gatewayConfig().baseUrl;
  return request;
};
